import { render, staticRenderFns } from "./tenant-manage.vue?vue&type=template&id=36a88855&"
import script from "./tenant-manage.vue?vue&type=script&lang=js&"
export * from "./tenant-manage.vue?vue&type=script&lang=js&"
import style0 from "./tenant-manage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports